import React, { useState } from "react";
import SampleDashboardLayout from "./SampleDashboardLayout";
import { Link } from "react-router-dom";
import Notification from "../../../components/Notification/Notification";
import { useSelector } from "react-redux";

const SampleNotification = () => {
  const [showFields, setShowFields] = useState("");
  const user = useSelector((state) => state.AuthSlice.user);

  const toggleDataReq = (index) => {
    setShowFields((prev) => (prev === index ? "" : index));
  };

  // STARS RATING
  const [rating, setRating] = useState(0); // State to store the selected rating

  // Function to handle star click
  const handleRating = (index) => {
    setRating(index + 1); // Save rating (1-based index)
  };

  return (
    <>
      <SampleDashboardLayout>
        <Notification userId={user?.id} />
      </SampleDashboardLayout>
    </>
  );
};

export default SampleNotification;
